import store from '../store'

export const ASSESSMENT_STATE_PERSON_INFO='person.info',
  ASSESSMENT_STATE_PERSON_PROFILEPIC='person.profilepic',
  ASSESSMENT_STATE_ORIENTATION='orientation',
  ASSESSMENT_STATE_JOURNEY_ORIENTATION='journey.orientation',
  ASSESSMENT_STATE_JOURNEY='journey'
;

export default function(navigate){
  const assessment=store.state.assessment.assessment;

  if(!assessment){
    console.warn('Assessment state router got an empty assessment. Logging out.');
    store.dispatch('auth/logout',{navigate:true});
  }

  switch (assessment.current_state) {
    case ASSESSMENT_STATE_PERSON_INFO : navigate({name:'OrientationVideo'}); break;
    //case ASSESSMENT_STATE_PERSON_INFO : navigate({name:'RegisterPersonInfo'}); break;
    case ASSESSMENT_STATE_PERSON_PROFILEPIC : navigate({name:'RegisterProfilePicture'}); break;
    case ASSESSMENT_STATE_ORIENTATION : navigate({name:'OrientationVideo'}); break;
    case ASSESSMENT_STATE_JOURNEY_ORIENTATION : navigate({name:'JourneyOrientation'}); break;
    case ASSESSMENT_STATE_JOURNEY : navigate({name:'Journey'}); break;
    default : navigate({name:'RegisterPersonInfo'});
  }
}